import React, { useState, useEffect } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  ListItemIcon,
  ListItemText,
  TextField,
  Divider,
  Box,
  Snackbar,
  Alert as MuiAlert,
} from "@mui/material";
import BookmarkAddIcon from "@mui/icons-material/BookmarkAdd";
import AddTaskIcon from "@mui/icons-material/AddTask";
import AddIcon from "@mui/icons-material/Add";

const SaveToCanvasButton = ({ chartData, currentFilters = {} }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [canvasNames, setCanvasNames] = useState([]);
  const [newCanvasName, setNewCanvasName] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const open = Boolean(anchorEl);

  const loadCanvasNames = () => {
    const stored = JSON.parse(localStorage.getItem("canvasData")) || {};
    setCanvasNames(Object.keys(stored));
  };

  useEffect(() => {
    loadCanvasNames();

    const handleCanvasUpdate = () => {
      loadCanvasNames();
    };

    const handleStorageChange = (e) => {
      if (e.key === "canvasData") {
        loadCanvasNames();
      }
    };
    window.addEventListener("canvasUpdated", handleCanvasUpdate);
    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("canvasUpdated", handleCanvasUpdate);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
    loadCanvasNames();
  };

  const handleClose = () => setAnchorEl(null);

  const handleSelectCanvas = (canvasName) => {
    const stored = JSON.parse(localStorage.getItem("canvasData")) || {};
    console.log(chartData)
    const deepCopiedFilters = JSON.parse(
      JSON.stringify({
        ...chartData.filters,
        ...currentFilters,
      })
    );

    const chartWithFilters = {
      ...chartData,
      filters: deepCopiedFilters,
    };

    console.log("[SaveToCanvasButton] Saving chart data:", chartData);
    console.log("[SaveToCanvasButton] Chart componentName:", chartData.componentName);
    console.log("[SaveToCanvasButton] Chart name:", chartData.name);
    console.log("[SaveToCanvasButton] Saving filters:", deepCopiedFilters);

    const updated = {
      ...stored,
      [canvasName]: [...(stored[canvasName] || []), chartWithFilters],
    };
    console.log(chartWithFilters);
    console.log(updated)
    localStorage.setItem("canvasData", JSON.stringify(updated));
    handleClose();

    setSnackbarMessage(`Saved chart to "${canvasName}"`);
    setShowSnackbar(true);

    window.dispatchEvent(new Event("canvasUpdated"));
  };

  const handleAddNewCanvas = () => {
    const trimmedName = newCanvasName.trim();
    if (!trimmedName) return;

    const stored = JSON.parse(localStorage.getItem("canvasData")) || {};

    if (stored[trimmedName]) {
      setSnackbarMessage(`Canvas "${trimmedName}" already exists`);
      setSnackbarSeverity("error");
      setShowSnackbar(true);
      return;
    }

    stored[trimmedName] = [];
    localStorage.setItem("canvasData", JSON.stringify(stored));
    setCanvasNames([...canvasNames, trimmedName]);
    setNewCanvasName("");
    window.dispatchEvent(new Event("canvasUpdated"));

    setSnackbarMessage(`"${trimmedName}" canvas created successfully`);
    setSnackbarSeverity("success");
    setShowSnackbar(true);
  };

  return (
    <>
      <Tooltip title="Save to Canvas">
        <IconButton onClick={handleOpen} size="large" sx={{ "& .MuiSvgIcon-root": { fontSize: 24 } }}>
          <BookmarkAddIcon />
        </IconButton>
      </Tooltip>

      <Menu
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        MenuListProps={{
          disableAutoFocusItem: true,
          disableListWrap: true,
        }}
      >
        {canvasNames.map((name) => (
          <MenuItem key={name} onClick={() => handleSelectCanvas(name)}>
            <ListItemIcon>
              <AddTaskIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={name} />
          </MenuItem>
        ))}

        <Divider />

        <Box sx={{ p: 1 }}>
          <TextField
            size="small"
            placeholder="New Canvas Name"
            value={newCanvasName}
            onChange={(e) => setNewCanvasName(e.target.value)}
            onKeyDown={(e) => {
              e.stopPropagation();
              if (e.key === "Enter") handleAddNewCanvas();
            }}
            fullWidth
          />
          <IconButton onClick={handleAddNewCanvas} size="small">
            <AddIcon fontSize="small" />
          </IconButton>
        </Box>
      </Menu>

      {/* Snackbar Message */}
      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => setShowSnackbar(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        sx={{
          position: "fixed",
          zIndex: 9999,
        }}
      >
        <MuiAlert
          onClose={() => setShowSnackbar(false)}
          severity={snackbarSeverity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
};

export default SaveToCanvasButton;
